<div class="index-items">
  <form class="index-items__controls-form" [formGroup]="form">
    <input class="index-items__controls-input" type="text" formControlName="itemName" placeholder="Введите название">
    <input class="index-items__controls-input" type="text" formControlName="itemShortName"
           placeholder="Условное обозначение">
    <button class="index-items__controls-button" color="primary" (click)="addItem()">Добавить</button>
  </form>
  <div class="index-items__list" cdkDropList (cdkDropListDropped)="drop($event)">
    @for (item of _items; track item) {
      <div cdkDrag>
        <pas-fill-badge [item]="item" (removeItem)="removeItem(item)"/>
      </div>
    }
  </div>
</div>
